import { ID } from "src/libs/interfaces/layouts"
import { useLandingStore } from "../../data/store"
import LandingCompositeDefault from "./LandingCompositeDefault"
import { ILandingContent } from "../../data/interfaces"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"

/* Protopia Ecosystem component */
export interface ILandingCompositeContentProps extends ICompositeWidgetProps {
    component: string 
    i: number
    value: any[]
    onValue: (value: any[]) => void
    val: any
    schemaType: any
    required: boolean
    isDeleted?: boolean 
    dataName: string
    dataSection: string
    origin: any
    children?: JSX.Element
}
const LandingCompositeContent = (props: ILandingCompositeContentProps): JSX.Element => { 
    
    const onSwitch = (i: number) => {
        props.value.splice( i + 2, 0, props.value[i] )
        props.value.splice( i, 1 ) 
        if(props.onChange) {           
            props.onChange( props.value, props.dataSection, "" )
        }
    }
    const onDelete = (id: ID) => {
        if( Array.isArray( props.value ) ) {
            const newValue = [ ...props.value ].filter( v => v.id !== id )
            props.onValue( newValue ) 
            if(props.onChange) {           
                props.onChange( newValue, props.dataSection, "" )
            }
        }
    }

    const  getDefaultOpenMeat = ( i: number, id: ID ): boolean => {
        switch( props.component) {
            case "LandingContent":
                const n = useLandingStore.getState().sectionEditMeatID 
                if(id === n) {
                    useLandingStore.getState({sectionEditMeatID: ""})
                }
                return id === n
            default:
                return false
        }
    }
    const onChangeArray = ( _value: any, field: string, data: any, dataId: ID ) => {
        console.log(_value, field, data, dataId )
        const newVal = (props.value ).map((meat: ILandingContent ) => {
            if( meat.id === dataId) { 
                return {
                    ...meat, 
                    [field] : _value
                }
            }
            return meat
        })               
        props.onValue( newVal ) 

        if(props.onChange) {           
            props.onChange( newVal, props.dataSection, "" )
        }
    }
    return <LandingCompositeDefault
            key={ props.val.id }
            title={ props.title }
            schemaType={{ ...props.schemaType }}
            isDefaultOpen={ getDefaultOpenMeat( props.i, props.val.id ) }
            isAlwaysOpen={ props.isAlwaysOpen }
            value={{ ...props.val }}
            required={props.required}
            type={ props.val.type || props.component } 
            isDeleted={ props.isDeleted }
            dataName={props.dataName}
            dataSection={props.dataSection}
            /* Only for components() (not like "DontNavigationItem" ets.) */
            origin={ 
                !!props.origin 
                    ?  
                    !!props.origin[ props.val.type || props.component ] 
                        ? 
                        props.origin[ props.val.type || props.component ]
                        :
                        !!props.origin.data
                            ?
                            props.origin.data[props.i]
                            :
                            {}
                    : 
                    {} 
            }
            i={ props.i } 
            children={ props.children }
            length={ props.value.length }
            onDelete={ onDelete }
            onSwitch={ onSwitch }
            onChange={ ( value: any, field: string, data: any ) => onChangeArray( value, field, data, props.val.id ) }
        />
}
export default LandingCompositeContent